import { CountryCodeSelector } from '@/helpers/CountryCodeSelector';
import { Button, Form, Input, Select } from 'antd';
import React, { FC, useState } from 'react';
import { ArrowRightOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import countries from '@/helpers/countries';

type Props = {
  // classInfo: Number;
  submitToSummary: (data: {}) => void;
  backBtn: () => void;
  startTime: string;
  endTime: string;
};

const BasicDetails: FC<Props> = ({
  submitToSummary,
  backBtn,
  startTime,
  endTime,
}) => {
  const [form] = Form.useForm();

  const [code, setCode] = useState('+977');
  const { Option } = Select;
  const onFinish = (values: any) => {
    const newValue = {
      ...values,
      phone_number: `${code}-${values?.phone_number}`,
      start_time: startTime,
      end_time: endTime,
    };
    submitToSummary(newValue);
  };
  return (
    <div className="mt-3">
      <p className="font-weight-bold mb-3" style={{ fontSize: '20px' }}>
        Basic Details
      </p>
      <Form form={form} onFinish={onFinish}>
        <div>
          <Form.Item
            label="First Name"
            name="first_name"
            rules={[{ required: true, message: 'First Name is required!' }]}
            className="mb-2"
          >
            <Input className="py-2 rounded-lg" name="fisrt_name" />
          </Form.Item>
          <Form.Item
            label="Last Name"
            name="last_name"
            rules={[{ required: true, message: 'Last Name is required!' }]}
            className="mb-2"
          >
            <Input className="py-2 rounded-lg" name="last_name" />
          </Form.Item>
          <Form.Item
            label="Email"
            name="email"
            rules={[{ required: true, message: 'Email Address is required!' }]}
            className="mb-2"
          >
            <Input className="py-2 rounded-lg" name="email" type="email" />
          </Form.Item>
          <Form.Item
            label="Address"
            name="address"
            rules={[{ required: true, message: 'Address is required!' }]}
            className="mb-2"
          >
            <Input className="py-2 rounded-lg" name="address" type="text" />
          </Form.Item>

          <div className="form-row">
            <div className="col-lg-4 col-md-12">
              <Form.Item label=" Country Code">
                <CountryCodeSelector
                  onChange={(val) => {
                    setCode(val);
                  }}
                  defaultValue={'+977'}
                />
              </Form.Item>
            </div>
            <div className="col-lg-8 col-md-12">
              <div className="form-group">
                <Form.Item
                  label=" Phone number"
                  name="phone_number"
                  rules={[{ required: true, message: 'Phone Number is required!' }]}
                  className="mb-2"
                >
                  <Input className="py-2 rounded-lg" name="phone_number" />
                </Form.Item>
              </div>
            </div>
          </div>

          <div className="d-flex gap-2 float-right">
            <Form.Item>
              <Button className="float-right" onClick={backBtn}>
                <div className="d-flex gap-2 align-items-center">
                  <ArrowLeftOutlined rev="" /> Back
                </div>
              </Button>
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="float-right"
                //   loading={addPartnerLoading || editPartnerLoading}
              >
                <div className="d-flex gap-2 align-items-center">
                  Summary <ArrowRightOutlined rev="" />
                </div>
              </Button>
            </Form.Item>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default BasicDetails;
